import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ExportBidResponsesMutation,
  ExportBidResponsesMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const exportBidResponses = graphql(`
  mutation exportBidResponses(
    $filters: BidResponsesRequest!
    $exportFormat: ExportFormatArgs!
    $selectedFields: [String!]
  ) {
    exportBidResponses(
      BidResponsesRequest: $filters
      ExportFormat: $exportFormat
      SelectedFields: $selectedFields
    ) {
      id
    }
  }
`);

export function useBidResponseExport(
  options?: UseMutationOptions<
    ExportBidResponsesMutation,
    unknown,
    ExportBidResponsesMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(exportBidResponses, options);
  return { ...rest, data: data?.exportBidResponses };
}
